import React from 'react';
import { useIntl } from 'react-intl';
import {
  Card, CardBody, CardFooter,
} from 'reactstrap';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Loading skeleton for the Property Settings page.
 * Mirrors the layout of `PropertySettings/index.jsx`: breadcrumbs, heading,
 * settings form card skeleton, and section headings for tariffs and users.
 * @returns {React.ReactElement} Placeholder component.
 */
function Placeholder() {
  const intl = useIntl();

  const breadcrumbsProperties = intl.formatMessage({
    id: 'property.property_settings.placeholder.breadcrumbs.properties',
    defaultMessage: 'Properties',
  });
  const breadcrumbsSettings = intl.formatMessage({
    id: 'property.property_settings.placeholder.breadcrumbs.settings',
    defaultMessage: 'Settings',
  });
  const headingSettings = intl.formatMessage({
    id: 'property.property_settings.placeholder.heading.settings',
    defaultMessage: 'Property Settings',
  });
  const generalSettingsTitle = intl.formatMessage({
    id: 'property.property_settings.placeholder.general_settings.title',
    defaultMessage: 'General Settings',
  });
  const tariffsTitle = intl.formatMessage({
    id: 'property.property_settings.placeholder.tariffs.title',
    defaultMessage: 'Active tariffs by meter',
  });
  const usersTitle = intl.formatMessage({
    id: 'property.property_settings.placeholder.users.title',
    defaultMessage: 'Users',
  });

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          { name: breadcrumbsProperties, path: '/properties' },
          { name: <span className="placeholder placeholder-glow bg-darken" style={{ width: '10rem' }} /> },
          { name: breadcrumbsSettings },
        ]}
      />
      <Heading
        title={<span className="placeholder placeholder-glow bg-darken" style={{ width: '12rem' }} />}
        subtitle={<span className="placeholder placeholder-glow bg-darken" style={{ width: '18rem' }} />}
        context={headingSettings}
      />

      <h2>{generalSettingsTitle}</h2>
      <p>
        <span className="placeholder placeholder-glow bg-darken col-8" />
      </p>

      <Card className="mt-4 mb-4" aria-hidden="true">
        <CardBody>
          {[0, 1, 2].map((idx) => (
            <div className="mb-3" key={`placeholder-field-${idx}`}>
              <div className="mb-1">
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '5rem' }} />
              </div>
              <span
                className="placeholder placeholder-glow bg-darken col-12"
                style={{ height: '2.375rem', borderRadius: '0.25rem' }}
              />
            </div>
          ))}
        </CardBody>
        <CardFooter>
          <span
            className="placeholder placeholder-glow bg-darken"
            style={{ width: '5rem', height: '2.375rem', borderRadius: '0.25rem' }}
          />
        </CardFooter>
      </Card>

      <div className="d-flex flex-wrap">
        <h2>{tariffsTitle}</h2>
      </div>
      <p>
        <span className="placeholder placeholder-glow bg-darken col-9" />
      </p>

      <Card className="mt-4 mb-4" aria-hidden="true">
        <CardBody>
          {[0, 1].map((idx) => (
            <div className="mb-3" key={`placeholder-meter-${idx}`}>
              <span className="placeholder placeholder-glow bg-darken col-4" />
              <br />
              <span className="placeholder placeholder-glow bg-darken col-8" />
            </div>
          ))}
        </CardBody>
      </Card>

      <hr />

      <h2>{usersTitle}</h2>
      <p>
        <span className="placeholder placeholder-glow bg-darken col-7" />
      </p>

      <Card className="mt-4 mb-4" aria-hidden="true">
        <CardBody>
          {[0, 1, 2].map((idx) => (
            <div className="mb-2" key={`placeholder-user-${idx}`}>
              <span className="placeholder placeholder-glow bg-darken col-6" />
            </div>
          ))}
        </CardBody>
      </Card>
    </>
  );
}

export default Placeholder;
